import React, { useEffect } from "react";

export default function LogoutModal(props) {
  const disableScroll = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  };

  const close = () => {
    props.setIsLogoutOpen(false);
    window.onscroll = function () {};
  };

  if (props.isOpen) {
    disableScroll()
  }

  useEffect(() => {
    if (props.isOpen) {
      disableScroll();
    }
  }, []);

  return (
    <div
      onClick={() => close()}
      className={`bg-[#00000025] w-screen h-screen z-50 ${
        props.isOpen ? `visible` : `hidden`
      } top-0 left-0 absolute transition-all flex items-center justify-center`}
    >
      <div className="w-[412px] h-[192px] bg-white-100 rounded-[8px] flex flex-col justify-center items-center">
        <h1 className="font-[700] text-[28px] text-[#1D1D1D]">{props.title}</h1>
        <p className="font-[400] text-[18px] text-[#666666] pt-[16px] pb-[16px] text-center">
          {props.description}
        </p>
        {
          !props.iscompletion ?
          <>
          <div className="flex justify-center items-center gap-[24px]">
          <button
            onClick={() => props.onLogout()}
            className="text-[#CF0000] border-[#CF0000] border-[2px] w-[154px] h-[42px] font-[600] text-[18px] rounded-[6px]"
          >
            {props.primaryText}
          </button>
          <button
            onClick={() => props.onBackToPortal()}
            className="text-[#FFFFFF] bg-[#CF0000] w-[154px] h-[42px] font-[600] text-[18px] rounded-[6px]"
          >
            {props.secondaryText}
          </button>
        </div>
        </>
        :
        <>
        <div className="flex justify-center items-center gap-[24px]">
          <button
            onClick={() => props.onLogoutCompletion()}
            className="text-[#CF0000] border-[#CF0000] border-[2px] w-[308px] h-[42px] font-[600] text-[18px] rounded-[6px]"
          >
            {props.primaryText}
          </button>
          {/* <button
            onClick={() => props.onBackToPortal()}
            className="text-[#FFFFFF] bg-[#CF0000] w-[154px] h-[42px] font-[600] text-[18px] rounded-[6px]"
          >
            {props.secondaryText}
          </button> */}
        </div>
        </>
        }
      </div>
    </div>
  );
}
